import { render, staticRenderFns } from "./GlobalLoading.vue?vue&type=template&id=530fddc9&scoped=true"
import script from "./GlobalLoading.vue?vue&type=script&lang=js"
export * from "./GlobalLoading.vue?vue&type=script&lang=js"
import style0 from "./GlobalLoading.vue?vue&type=style&index=0&id=530fddc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530fddc9",
  null
  
)

export default component.exports